var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "125px",
    height: "120px",
    viewBox: "0 0 125 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "2.15170632e-14 0 6.59993565 0 6.59993565 6.62097249 2.15170632e-14 6.62097249"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 1.07925761e-14 4.92091832 1.07925761e-14 4.92091832 4.93641421 0 4.93641421"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 0 3.27316775 0 3.27316775 3.2832596 0 3.2832596"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kepler-passport-\\u8D2D\\u4E70\\u6210\\u529F",
    transform: "translate(-892.000000, -246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-16",
    transform: "translate(892.000000, 246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    opacity: 0.400000006
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(118.015394, 50.239989)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60008706,3.31048624 C6.60008706,5.13888625 5.12267597,6.62097249 3.30004353,6.62097249 C1.47778962,6.62097249 2.15170632e-14,5.13888625 2.15170632e-14,3.31048624 C2.15170632e-14,1.48208624 1.47778962,0 3.30004353,0 C5.12267597,0 6.60008706,1.48208624 6.60008706,3.31048624",
    id: "Fill-1",
    fill: "#0084f4",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.1554505,108.072339 C46.1554505,110.570203 44.1367384,112.595303 41.6463752,112.595303 C39.1563906,112.595303 37.1376785,110.570203 37.1376785,108.072339 C37.1376785,105.574095 39.1563906,103.548995 41.6463752,103.548995 C44.1367384,103.548995 46.1554505,105.574095 46.1554505,108.072339",
    id: "Fill-3",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.764862,14.475384 C102.764862,15.724316 101.755695,16.737056 100.510703,16.737056 C99.2653321,16.737056 98.2561653,15.724316 98.2561653,14.475384 C98.2561653,13.2260723 99.2653321,12.2137121 100.510703,12.2137121 C101.755695,12.2137121 102.764862,13.2260723 102.764862,14.475384",
    id: "Fill-5",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9007426,15.412102 C40.9007426,17.2799939 39.3915348,18.7943572 37.5291564,18.7943572 C35.6671567,18.7943572 34.1579489,17.2799939 34.1579489,15.412102 C34.1579489,13.5442101 35.6671567,12.0298468 37.5291564,12.0298468 C39.3915348,12.0298468 40.9007426,13.5442101 40.9007426,15.412102",
    id: "Fill-7",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8793933,15.412102 C76.8793933,17.178606 75.4519485,18.6105679 73.6910168,18.6105679 C71.9304636,18.6105679 70.5026403,17.178606 70.5026403,15.412102 C70.5026403,13.645598 71.9304636,12.2136361 73.6910168,12.2136361 C75.4519485,12.2136361 76.8793933,13.645598 76.8793933,15.412102",
    id: "Fill-9",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2620831,47.3856348 C22.2620831,49.8838786 20.243371,51.9089787 17.7530078,51.9089787 C15.2630231,51.9089787 13.244311,49.8838786 13.244311,47.3856348 C13.244311,44.8873911 15.2630231,42.8622909 17.7530078,42.8622909 C20.243371,42.8622909 22.2620831,44.8873911 22.2620831,47.3856348",
    id: "Fill-11",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21549837,60.6945262 C6.21549837,62.4162221 4.82401408,63.8121096 3.10774918,63.8121096 C1.39148429,63.8121096 0,62.4162221 0,60.6945262 C0,58.9728303 1.39148429,57.5769428 3.10774918,57.5769428 C4.82401408,57.5769428 6.21549837,58.9728303 6.21549837,60.6945262",
    id: "Fill-13",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4856,29.6564203 C99.4856,31.3781162 98.0941157,32.7740037 96.3778508,32.7740037 C94.6612074,32.7740037 93.2697231,31.3781162 93.2697231,29.6564203 C93.2697231,27.9343447 94.6612074,26.5388369 96.3778508,26.5388369 C98.0941157,26.5388369 99.4856,27.9343447 99.4856,29.6564203",
    id: "Fill-15",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.013387,93.7379103 C112.013387,95.6851658 110.439829,97.2640832 108.498338,97.2640832 C106.557225,97.2640832 104.983666,95.6851658 104.983666,93.7379103 C104.983666,91.7906548 106.557225,90.2117375 108.498338,90.2117375 C110.439829,90.2117375 112.013387,91.7906548 112.013387,93.7379103",
    id: "Fill-17",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0318535,96.2061554 C21.0318535,97.5693862 19.9303248,98.6744005 18.5713943,98.6744005 C17.2124638,98.6744005 16.1109352,97.5693862 16.1109352,96.2061554 C16.1109352,94.8429247 17.2124638,93.7379103 18.5713943,93.7379103 C19.9303248,93.7379103 21.0318535,94.8429247 21.0318535,96.2061554",
    id: "Fill-19",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.879393, 115.063586)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.92091832,2.46824508 C4.92091832,3.83147582 3.81938968,4.93649016 2.46045916,4.93649016 C1.10152864,4.93649016 0,3.83147582 0,2.46824508 C0,1.10501433 1.10152864,1.07925761e-14 2.46045916,1.07925761e-14 C3.81938968,1.07925761e-14 4.92091832,1.10501433 4.92091832,2.46824508",
    id: "Fill-21",
    fill: "#0084f4",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.5713943,77.326245 C18.5713943,78.0078604 18.02063,78.5603676 17.3411647,78.5603676 C16.6616995,78.5603676 16.1109352,78.0078604 16.1109352,77.326245 C16.1109352,76.6446297 16.6616995,76.0921225 17.3411647,76.0921225 C18.02063,76.0921225 18.5713943,76.6446297 18.5713943,77.326245",
    id: "Fill-23",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4175021,106.515597 C63.4175021,107.422393 62.6846638,108.15717 61.7807289,108.15717 C60.8767941,108.15717 60.1443343,107.422393 60.1443343,106.515597 C60.1443343,105.608802 60.8767941,104.874025 61.7807289,104.874025 C62.6846638,104.874025 63.4175021,105.608802 63.4175021,106.515597",
    id: "Fill-25",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.771657,32.7740037 C111.771657,33.680799 111.038818,34.4155765 110.135262,34.4155765 C109.231327,34.4155765 108.498489,33.680799 108.498489,32.7740037 C108.498489,31.8672084 109.231327,31.1324308 110.135262,31.1324308 C111.038818,31.1324308 111.771657,31.8672084 111.771657,32.7740037",
    id: "Fill-27",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9451065,106.515597 C88.9451065,107.422393 88.2118897,108.15717 87.3083334,108.15717 C86.4043985,108.15717 85.6719388,107.422393 85.6719388,106.515597 C85.6719388,105.608802 86.4043985,104.874025 87.3083334,104.874025 C88.2118897,104.874025 88.9451065,105.608802 88.9451065,106.515597",
    id: "Fill-29",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4983,71.382597 C108.4983,72.2893922 107.765461,73.0241698 106.861905,73.0241698 C105.95797,73.0241698 105.225511,72.2893922 105.225511,71.382597 C105.225511,70.4758017 105.95797,69.7410241 106.861905,69.7410241 C107.765461,69.7410241 108.4983,70.4758017 108.4983,71.382597",
    id: "Fill-31",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.780805, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.27316775,1.64168676 C3.27316775,2.54848203 2.54032945,3.2832596 1.63677314,3.2832596 C0.732838297,3.2832596 0,2.54848203 0,1.64168676 C0,0.734891492 0.732838297,-0.000265811008 1.63677314,-0.000265811008 C2.54032945,-0.000265811008 3.27316775,0.734891492 3.27316775,1.64168676",
    id: "Fill-33",
    fill: "#0084f4",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.7854669,18.6104919 C50.7854669,19.5172872 50.0526286,20.2520648 49.1490723,20.2520648 C48.2451374,20.2520648 47.5126777,19.5172872 47.5126777,18.6104919 C47.5126777,17.7036967 48.2451374,16.9685394 49.1490723,16.9685394 C50.0526286,16.9685394 50.7854669,17.7036967 50.7854669,18.6104919",
    id: "Fill-35",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7860978,32.7740037 C30.7860978,33.680799 30.0532595,34.4155765 29.1497032,34.4155765 C28.2457683,34.4155765 27.51293,33.680799 27.51293,32.7740037 C27.51293,31.8672084 28.2457683,31.1324308 29.1497032,31.1324308 C30.0532595,31.1324308 30.7860978,31.8672084 30.7860978,32.7740037",
    id: "Fill-37",
    fill: "#0084f4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.8173187,62.0001384 C94.8173187,78.0163258 81.8746007,91 65.9086593,91 C49.942718,91 37,78.0163258 37,62.0001384 C37,45.9836742 49.942718,33 65.9086593,33 C81.8746007,33 94.8173187,45.9836742 94.8173187,62.0001384 L94.8173187,62.0001384 Z",
    id: "Fill-39",
    fill: "#0084f4"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#ffffff",
    points: "75.3613949 53 77.8309177 55.4695228 62.3005861 71 53 61.8286129 55.470555 59.3580579 62.2958803 66.1832453"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.9912c4f3c8dd8003fe8e56240a094513.svg";
export { ForwardRef as ReactComponent };